import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/marketing/komunikace")({
  beforeLoad: requirePermissionGuard("hca.crm.read"),
});
